import apiWorker from '../apiWorker'

const call_logs = {

    findByContact: (contact_id) =>  apiWorker('get',   `/api/v1/call_center/call_logs/find/contact/${contact_id}`),

}

export default call_logs;